module.exports = __webpack_public_path__ + "img/25.b31db515.jpg";